import * as React from 'react'
import { View } from 'react-native'
import styled from '@theme/styled-components'

import Root from '@components/root/Root'
import Picker from '@components/picker/Picker'

import useI18n from '@i18n/useI18n'
import useNavigation from '@layout/useNavigation'

import useReducer from '@store/useReducer'
import * as UserStore from '@store/user/user'

import api from '@api/api'
import logger from '@utils/logger'
import { Langage } from '@api/enum'

const AccountLangScreen = () => {
  const i18n = useI18n()
  const navigation = useNavigation()

  const user = useReducer(UserStore.store, (s) => s.user)

  const langOptions = i18n.supportedLang.map((key) => ({ value: key, label: i18n.t(`lang.${key}`) }))

  const onLanguageChange = (opt?: PickerOption) => {
    if (opt && user) {
      api.users
        .updateUser({ ...user, langage: opt.value === 'fr' ? Langage.FR : Langage.EN })
        .then(UserStore.actions.setUser)
        .catch(logger.error)
    }
  }

  return (
    <Root onLeft={navigation.goBack} header={i18n.t('screens.account.mobileSections.lang')}>
      <MainContainer>
        <Picker
          options={langOptions}
          onChange={onLanguageChange}
          value={langOptions.find((opt) => opt.value === i18n.lang)}
        />
      </MainContainer>
    </Root>
  )
}

export default AccountLangScreen

const MainContainer = styled(View)`
  padding: 24px 16px;
`
